/** Secondary nav under “Management2” — duplicate entry points; does not replace `/vms/certifications` or `/vms/flow-stakeholders`. */

export const MANAGEMENT2_CERTIFICATIONS_LIST_PATH = '/vms/management2/certifications-licenses';
export const MANAGEMENT2_FLOW_STAKEHOLDERS_LIST_PATH = '/vms/management2/flow-stakeholders';

const MANAGEMENT2_NAV_PREFIX = '/vms/management2/';

/** True for routes served from the Management2 flyout (used by nav partition + layout guards). */
export function isManagement2NavPath(pathname: string): boolean {
  return pathname.startsWith(MANAGEMENT2_NAV_PREFIX);
}
